import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const OcurrenceByForwarding = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Ocorrências com regulação por encaminhamento (5+)'}
            horizontal={false}
            subtitles={chartData?.ocurrenceByForwarding?.map((item) => item.description)}
            values={chartData?.ocurrenceByForwarding?.map((item) => item.total || 0)}
            stacked
        />
    );
};